
      import API from "!../../../../../tmp/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../tmp/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../tmp/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../tmp/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../tmp/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../tmp/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../tmp/node_modules/css-loader/dist/cjs.js!../../../../../tmp/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./CustomButton.scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../tmp/node_modules/css-loader/dist/cjs.js!../../../../../tmp/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./CustomButton.scss";
       export default content && content.locals ? content.locals : undefined;
